import styled from 'styled-components';

export const Sec = styled.section`
  width: 100%;
  padding: 5rem 2rem;
  background: ${({ bg }) => bg || '#fff'};
`;

export const SecInner = styled.div`
  max-width: 1240px;
  margin: 0 auto;
`;

export const TopLine = styled.p`
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: ${({ light }) => (light ? '#f3d99a' : '#c4980e')};
  margin: 0 0 0.75rem;
`;

export const SecH2 = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 700;
  line-height: 1.2;
  color: ${({ light }) => (light ? '#ffffff' : '#1c2237')};
  margin: 0 0 0.75rem;
`;

export const SecDesc = styled.p`
  color: ${({ light }) => (light ? 'rgba(226,232,240,.9)' : '#475569')};
  font-size: 1.03rem;
  line-height: 1.7;
  max-width: 680px;
  margin: 0 0 2rem;
`;

export const PkgHdr = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const PkgH1 = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 900;
  color: #1c2237;
  margin: 0 0 0.75rem;
`;

export const PkgSub = styled.p`
  color: #475569;
  font-size: 1.03rem;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
`;

export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const SportCardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;

  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

export const SportCard = styled.button`
  background: ${({ $sel }) => ($sel ? '#1c2237' : '#ffffff')};
  border: 2px solid ${({ $sel }) => ($sel ? '#c4980e' : '#e2e8f0')};
  border-radius: 16px;
  padding: 1rem;
  cursor: pointer;
  text-align: left;
  box-shadow: ${({ $sel }) => ($sel ? '0 10px 24px rgba(180,120,6,.24)' : '0 4px 14px rgba(15,23,42,.08)')};

  .sh {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin-bottom: 0.35rem;
  }

  .si {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${({ $sel }) => ($sel ? 'rgba(243,217,154,.16)' : 'rgba(196,152,14,.12)')};
    color: ${({ $sel }) => ($sel ? '#f3d99a' : '#b47806')};
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  .sn {
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: ${({ $sel }) => ($sel ? '#ffffff' : '#1c2237')};
    margin-bottom: 0.2rem;
  }

  .sp {
    font-family: 'Poppins', sans-serif;
    font-size: 1.35rem;
    font-weight: 800;
    color: ${({ $sel }) => ($sel ? '#f3d99a' : '#c4980e')};
    line-height: 1;
  }

  .sd {
    color: ${({ $sel }) => ($sel ? 'rgba(226,232,240,.86)' : '#64748b')};
    font-size: 0.8rem;
    margin-top: 0.2rem;
  }
`;

export const RightBox = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 1.4rem;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.1);
`;

export const FeatRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-of-type {
    border-bottom: none;
  }

  i {
    color: #16a34a;
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  span {
    font-size: 0.92rem;
    color: #334155;
    font-weight: 500;
  }
`;

export const CheckoutCard = styled.div`
  margin-top: 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1rem;
`;

export const Input = styled.input`
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #ffffff;
  color: #0f172a;
  padding: 0.62rem 0.72rem;
  font-size: 0.92rem;
`;

export const ActionBtn = styled.button`
  background: linear-gradient(#f0c876 0%, #b47806 100%);
  color: #0e0906;
  border: 0;
  border-radius: 10px;
  padding: 0.76rem 1rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 16px 36px -10px rgba(139, 94, 0, 0.65), 0 0 0 1px rgba(139, 94, 0, 0.52) inset;
  width: 100%;
`;

export const HowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin: 1rem 0 2rem;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;

export const HowStep = styled.div`
  background: rgba(255,255,255,.06);
  border: 1px solid rgba(240,200,118,.22);
  border-radius: 16px;
  padding: 1.25rem;
  position: relative;

  h4 { margin: 0.5rem 0 0.35rem; font-family: 'Poppins', sans-serif; color: #fff; font-size: 0.95rem; font-weight: 700; }
  p  { margin: 0; color: #e2e8f0; font-size: 0.85rem; line-height: 1.6; }
`;

export const HowNum = styled.span`
  position: absolute;
  top: -10px; left: 14px;
  background: linear-gradient(#f0c876 0%, #b47806 100%);
  color: #0e0906;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  font-size: 0.72rem;
  padding: 1px 7px;
  border-radius: 50px;
  letter-spacing: 0.04em;
`;

export const HowIcon = styled.div`
  width: 40px; height: 40px;
  border-radius: 10px;
  background: rgba(196,152,14,.18);
  display: flex; align-items: center; justify-content: center;
  color: #f3d99a; font-size: 1.1rem;
  margin-bottom: 0.35rem;
`;

export const HowFeatures = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;

  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

export const HowFeat = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(240,200,118,.15);
  border-radius: 12px;
  padding: 0.85rem;

  & > i { color: #f3d99a; font-size: 1rem; margin-top: 2px; flex-shrink: 0; }

  div { display: flex; flex-direction: column; gap: 0.15rem; }
  strong { color: #ffffff; font-size: 0.88rem; }
  span   { color: #cbd5e1; font-size: 0.82rem; line-height: 1.55; }
`;

export const SysDocGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

export const SysDocCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 4px 14px rgba(15,23,42,.07);

  .ico {
    width: 42px; height: 42px;
    border-radius: 10px;
    background: rgba(196,152,14,.1);
    display: flex; align-items: center; justify-content: center;
    color: #c4980e; font-size: 1.1rem;
    margin-bottom: 0.65rem;
  }

  h4 { margin: 0 0 0.4rem; font-family: 'Poppins', sans-serif; color: #1c2237; font-size: 0.96rem; font-weight: 700; }
  p  { margin: 0; color: #475569; font-size: 0.88rem; line-height: 1.65; }
`;

export const Notice = styled.div`
  margin: 0 auto 1rem;
  max-width: 1240px;
  padding: 0.85rem 1.1rem;
  border-radius: 10px;
  border: 1px solid ${({ $error }) => ($error ? 'rgba(239,68,68,.42)' : 'rgba(16,185,129,.42)')};
  background: ${({ $error }) => ($error ? 'rgba(127,29,29,.12)' : 'rgba(6,95,70,.12)')};
  color: ${({ $error }) => ($error ? '#b91c1c' : '#065f46')};
  font-weight: 600;
`;

export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;


export const CheckoutStack = styled.div`
  display: grid;
  gap: 0.7rem;
`;

export const EmailGroup = styled.div`
  display: grid;
  gap: 0.35rem;
`;

export const EmailLabel = styled.label`
  color: #334155;
  font-weight: 600;
  font-size: 0.88rem;
`;

export const PasswordHint = styled.div`
  color: #64748b;
  font-size: 0.78rem;
  line-height: 1.45;
`;

export const SelectedPackageWrap = styled.div`
  border-top: 1px solid #e2e8f0;
  padding-top: 0.65rem;
`;

export const SelectedPackageLabel = styled.div`
  color: #64748b;
  font-size: 0.8rem;
`;

export const SelectedPackageName = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  color: #1c2237;
  font-size: 1.4rem;
`;

export const SelectedPackageMeta = styled.div`
  color: #64748b;
  font-size: 0.86rem;
`;

export const ErrorText = styled.div`
  color: #b91c1c;
  font-weight: 600;
  font-size: 0.86rem;
`;

export const DocsCtaWrap = styled.div`
  margin-top: 1.5rem;
`;

export const DocsCtaLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: linear-gradient(#f0c876 0%, #b47806 100%);
  color: #0e0906;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 700;
  text-decoration: none;
  font-size: 0.95rem;
  box-shadow: 0 8px 20px rgba(139,94,0,.4);
`;

export const PreviewInner = styled(SecInner)`
  display: grid;
  gap: 1.25rem;
`;

export const SkeletonLine = styled.span`
  display: inline-block;
  width: ${({ $w }) => $w || '100%'};
  height: ${({ $h }) => $h || '0.95rem'};
  border-radius: 8px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 45%, #e2e8f0 100%);
  background-size: 200% 100%;
  animation: shimmer 1.15s ease-in-out infinite;

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;
